module.exports = __webpack_public_path__ + "static/img/swoosh(2)0050.d02af28.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/swoosh/swoosh(2)0050.png
// module id = L+7o
// module chunks = 1